// extracted by mini-css-extract-plugin
module.exports = {"fileWrapper":"styles_fileWrapper__11g7b","fileExtension":"styles_fileExtension__1zbFr","fileName":"styles_fileName__pAiUc","removeIcon":"styles_removeIcon__3Vw7Y"};